export const getBaseTaxonomy = () => {
	const metaTags = [ 'sc:country', 'sc:language', 'sc:subcategories', 'sc:page-slug' ];
	const data = {};

	metaTags.forEach( ( name ) => {
		const metaTag = document.querySelector( `meta[name="${ name }"]` );

		if ( metaTag ) {
			data[ name ] = metaTag.getAttribute( 'content' );
		}
	} );

	return `${ data[ 'sc:country' ] }-${ data[ 'sc:language' ] } : ${ data[ 'sc:subcategories' ] } : ${ data[ 'sc:page-slug' ] }`;
};

export const getISIN = ( require_isin_on_wildcard = false ) => {
	const url_params = new URLSearchParams( window?.location?.search );
	const url_path = window?.location?.pathname || '';

	// We only have to pass ISIN on details and compare page.
	if ( url_path.includes( 'fund-details' ) ) {
		return url_params.get( 'isin' ) || 'na';
	} else if ( url_path.includes( 'funds-comparison' ) ) {
		return url_params.get( 'compare' ) || 'na';
	}

	// Sometimes we might require isin in some cases, irrespective of a page/event.
	if ( require_isin_on_wildcard ) {
		return url_params.get( 'compare' ) || 'na';
	}

	return 'na';
};
